<div class="autocomplete-container"
  [ngClass]="{ 'active': isOpen}">
  <div #inputContainerElement class="input-container">
    <input #searchInput
      class="text-uppercase"
      type="text"
      [maxlength]="maxLength"
      [placeholder]="placeHolder"
      [(ngModel)]=query
      (input)="onChange($event)"
      (paste)="onPaste($event)"
      (focusin)="toggleFocusClass()"
      (focus)=handleFocus($event)
      (keyup.enter)="onKeyupEnter()"
      (focusout)="onFocusOut()"
      [disabled]="disabled">
      @if (query && !isLoading && !disabled) {
        <div class="x" (click)="remove($event)">
          <i class="material-icons">close</i>
        </div>
      }
      <!--Loading mask-->
      @if (isLoading) {
        <div class="sk-fading-circle">
          <div class="sk-circle1 sk-circle"></div>
          <div class="sk-circle2 sk-circle"></div>
          <div class="sk-circle3 sk-circle"></div>
          <div class="sk-circle4 sk-circle"></div>
          <div class="sk-circle5 sk-circle"></div>
          <div class="sk-circle6 sk-circle"></div>
          <div class="sk-circle7 sk-circle"></div>
          <div class="sk-circle8 sk-circle"></div>
          <div class="sk-circle9 sk-circle"></div>
          <div class="sk-circle10 sk-circle"></div>
          <div class="sk-circle11 sk-circle"></div>
          <div class="sk-circle12 sk-circle"></div>
        </div>
      }
    </div>

    <!--FilteredList items-->
    <div class="suggestions-container"
      [ngClass]="{ 'is-hidden': isHistoryListVisible, 'is-visible': !isHistoryListVisible}">
      <!--FilteredList heading-->
      @if (filteredList.length > 0 && heading) {
        <div class="heading">
          <div class="text">{{heading}}</div>
        </div>
      }

      <ul #filteredListElement>
        @for (item of filteredList; track item; let idx = $index) {
          <li class="item" [title]="item[titleProperty]">
            <!--string logic-->
            @if (isType(item)) {
              <div [class.complete-selected]="idx === selectedIdx"
                (click)="select(item)">
                <ng-container
                  *ngTemplateOutlet="itemTemplate;  context: { $implicit: item | highlight: toHighlight }">
                </ng-container>
              </div>
            }
            <!--object logic-->
            @if (!isType(item)) {
              <div [class.complete-selected]="idx === selectedIdx"
                (click)="select(item)">
                <ng-container
                  *ngTemplateOutlet="itemTemplate; context: { $implicit: item | highlight: toHighlight : searchKeyword }">
                </ng-container>
              </div>
            }
          </li>
        }
      </ul>
    </div>

    <!--HistoryList items-->
    <div class="suggestions-container"
      [ngClass]="{ 'is-hidden': !isHistoryListVisible, 'is-visible': isHistoryListVisible}">
      <!--HistoryList heading-->
      @if (historyList.length > 0 && historyHeading) {
        <div class="heading">
          <div class="text">{{historyHeading}}</div>
          <div class="x" (click)="resetHistoryList($event)">
            <i class="material-icons">delete</i>
          </div>
        </div>
      }

      <ul #historyListElement>
        @for (item of historyList; track item; let idx = $index) {
          <li class="item">
            <!--string logic-->
            @if (isType(item)) {
              <div [class.complete-selected]="idx === selectedIdx" (click)="select(item)">
                <ng-container
                  *ngTemplateOutlet="itemTemplate;  context: { $implicit: item }">
                </ng-container>
              </div>
            }
            <!--object logic-->
            @if (!isType(item)) {
              <div [class.complete-selected]="idx === selectedIdx" (click)="select(item)">
                <ng-container
                  *ngTemplateOutlet="itemTemplate; context: { $implicit: item }">
                </ng-container>
              </div>
            }
            <div class="x" (click)="removeHistoryItem(idx, $event)">
              <i class="material-icons">close</i>
            </div>
          </li>
        }
      </ul>
    </div>

    <!--Not found-->
    @if (isLoading ? !isLoading && notFound : notFound) {
      <div class="not-found">
        <ng-container i18n="@@app.not_found">Not Found</ng-container>
      </div>
    }
  </div>
  @if (overlay) {
    <div class="overlay" (click)="handleOverlay()"></div>
  }
